import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals';
import { logPerformanceSummary } from './utils/performanceMonitoring';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Performance monitoring for Core Web Vitals
const reportWebVitals = (onPerfEntry?: (metric: any) => void) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    getCLS(onPerfEntry);
    getFID(onPerfEntry);
    getFCP(onPerfEntry);
    getLCP(onPerfEntry);
    getTTFB(onPerfEntry);
  }
};

// Monitor web vitals
reportWebVitals((metric) => {
  // Log vitals to console in development
  if (process.env.NODE_ENV === 'development') {
    let score = '⚠️ Needs Improvement';
    let threshold = 2500;
    
    if (metric.name === 'CLS') {
      threshold = 0.1;
      score = metric.value < threshold ? '✅ Good' : '⚠️ Needs Improvement';
    } else if (metric.name === 'FID') {
      threshold = 100;
      score = metric.value < threshold ? '✅ Good' : '⚠️ Needs Improvement';
    } else {
      score = metric.value < threshold ? '✅ Good' : '⚠️ Needs Improvement';
    }
    
    const unit = metric.name === 'CLS' ? '' : 'ms';
    console.log(`🎯 ${metric.name}: ${metric.value.toFixed(2)}${unit} ${score}`);
  }
  
  // In production, you would send these to your analytics service
  // Example: analytics.track('web-vital', metric);
});

// Log comprehensive performance summary after page load
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('load', () => {
    setTimeout(logPerformanceSummary, 3000);
  });
}
